<template>
  <section class="space-y-2 p-4">
    <viewTitle title="业务管理 / 报表管理 / 质检明细表" :showReturn="true">
      <template slot="return">
        <el-button
          v-has="['c-mpReport-record-inspectExport']"
          type="primary"
          @click="onExport"
          size="small"
          >导出</el-button
        >
      </template>
    </viewTitle>
    <el-form :inline="true" :model="queryParam" class="search-form-inline">
      <el-form-item label="基地">
        <el-select class="w-40" clearable v-model="queryParam.base_id">
          <el-option
            v-for="item in com_list"
            :key="item.com_id"
            :label="item.com_name"
            :value="item.com_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="磅单号">
        <el-input
          clearable
          v-model="queryParam.pound_code"
          placeholder="请输入磅单号"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="车牌号">
        <el-input
          clearable
          v-model="queryParam.license_plate"
          placeholder="请输入车牌号"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="进厂日期">
        <el-date-picker
          style="margin-bottom: 10px;"
          v-model="queryParam.into_time"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="出厂日期">
        <el-date-picker
          style="margin-bottom: 10px;"
          v-model="queryParam.out_time"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="取样完成时间">
        <el-date-picker
          style="margin-bottom: 10px;"
          v-model="queryParam.sampling_time"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="外观确认人员">
        <el-input
          clearable
          v-model="queryParam.begin_unload_user"
          placeholder="请输入外观确认人员"
          class="w-40"
        ></el-input>
      </el-form-item>
      <el-form-item label="外观确认时间">
        <el-date-picker
          style="margin-bottom: 10px;"
          v-model="queryParam.unload_time"
          type="datetimerange"
          align="right"
          unlink-panels
          range-separator="至"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          value-format="timestamp"
        ></el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="onSearch" type="primary" size="small">查询</el-button>
        <el-button @click="onReset" size="small">重置</el-button>
      </el-form-item>
    </el-form>
    <c-table
      class="mt-4"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="id"
      @loadPage="loadData"
    >
      <template slot="pound_code" slot-scope="{row}">
        <!-- <c-link>{{ row.pound_code }}</c-link> -->
         <c-link :underline="true" @click="onBookingDetail(row)">{{ row.pound_code }}</c-link>
      </template>
      <template slot="into_factory_time" slot-scope="{ row }">
        {{ row.into_factory_time | timeFormat("YYYY-MM-DD") }}
      </template>
      <template slot="leave_factory_time" slot-scope="{ row }">
        {{ row.leave_factory_time | timeFormat("YYYY-MM-DD") }}
      </template>
      <template slot="sampling_finish_time" slot-scope="{ row }">
        {{ row.sampling_finish_time | timeFormat }}
      </template>
      <template slot="unload_begin_time" slot-scope="{ row }">
        {{ row.unload_begin_time | timeFormat }}
      </template>
    </c-table>
    <div v-if="inspectReportTotalLoading" class="inspect-total-loading">
      正在统计总数，列表数据可先查看...
    </div>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import moment from "moment";
export default {
  data() {
    return {
      // 关闭 mixin 默认首屏加载，由页面设置默认时间范围后再主动查一次。
      disabledCreated: true,
      // 禁止输入条件时自动请求，避免慢查询在筛选过程中被连续触发。
      autoSearch: false,
      inspectReportTotalLoading: false,
      inspectReportTotalQueryKey: "",
      inspectReportListRequestSeq: 0,
      inspectReportTotalRequestSeq: 0,
      columns: [
        { label: "磅单号", prop: "pound_code" },
        { label: "加密号", prop: "package_no" },
        { label: "车牌号", prop: "license_plate" },
        { label: "物料类型", prop: "chip_type" },
        { label: "进厂日期", prop: "into_factory_time" },
        { label: "出厂日期", prop: "leave_factory_time" },
        { label: "取样地点", prop: "sampling_point_name" },
        { label: "实际系统加抽", prop: "is_system_sampling" },
        { label: "是否临时加抽", prop: "is_tmp_pumping" },
        { label: "取样完成时间", prop: "sampling_finish_time" },
        { label: "外观确认人员", prop: "begin_unloader_name" },
        { label: "外观确认时间", prop: "unload_begin_time" }
      ],
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/inspect_report_export",
          data: this.formatQueryParams(params),
          noLoading: true
        });
      }
    };
  },
  mixins: [initListMinxin],
  methods: {
    // 生成质检明细默认查询条件，首屏和重置默认限制在最近 7 天取样完成记录。
    getDefaultQueryParam() {
      const beginTime = moment()
        .startOf("days")
        .subtract("7", "days");
      const endTime = moment().endOf("days");

      return {
        base_id: "",
        pound_code: "",
        license_plate: "",
        into_time: [],
        out_time: [],
        sampling_time: [beginTime.valueOf(), endTime.valueOf()],
        begin_unload_user: "",
        unload_time: []
      };
    },
    // 重置时恢复默认 7 天窗口，避免清空时间后形成大范围统计查询。
    onReset() {
      this.pagintion.page = 1;
      this.queryParam = this.getDefaultQueryParam();
      this.onSearch();
    },
    // 查询时重置总数状态，确保新条件下异步拉取真实 COUNT。
    onSearch() {
      this.rowKeySelection = [];
      this.rowSelection = [];
      this.pagintion.page = 1;
      this.resetInspectReportTotal();
      this.loadData();
    },
    // 刷新列表时同步重置已选数据和总数统计状态。
    refreshData() {
      this.rowKeySelection = [];
      this.rowSelection = [];
      this.resetInspectReportTotal();
      this.loadData();
    },
    // 质检明细列表先跳过 COUNT 返回当前页，避免一年范围真实总数阻塞首屏。
    async loadData() {
      const requestSeq = ++this.inspectReportListRequestSeq;
      const params = this.buildInspectReportRequestParams();
      const totalQueryKey = this.buildInspectReportTotalQueryKey(params);

      try {
        this.dataSource = [];
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/inspect_report_list",
          data: Object.assign({}, params, { skip_total: 1 })
        });
        if (requestSeq !== this.inspectReportListRequestSeq) {
          return;
        }

        const result = dataObj.data.data || {};
        this.dataSource = result.data || [];
        if (this.inspectReportTotalQueryKey !== totalQueryKey) {
          this.inspectReportTotalQueryKey = totalQueryKey;
          this.total = 0;
          this.loadInspectReportTotal(params, totalQueryKey);
        }
      } catch (e) {
      }

      setTimeout(() => {
        if (this.loadCallBack) {
          this.loadCallBack();
        }
      }, 500);
    },
    // 异步拉取真实总数，返回前不展示分页总数，避免用估算值误导用户。
    async loadInspectReportTotal(params, totalQueryKey) {
      const requestSeq = ++this.inspectReportTotalRequestSeq;
      this.inspectReportTotalLoading = true;

      try {
        const dataObj = await this.$common.http({
          url: "/api/queue/admin/inspect_report_list",
          data: Object.assign({}, params, { only_total: 1 }),
          noLoading: true
        });
        if (
          requestSeq !== this.inspectReportTotalRequestSeq ||
          totalQueryKey !== this.inspectReportTotalQueryKey
        ) {
          return;
        }

        this.total = Number(dataObj.data.data.total) || 0;
      } catch (e) {
      } finally {
        if (
          requestSeq === this.inspectReportTotalRequestSeq &&
          totalQueryKey === this.inspectReportTotalQueryKey
        ) {
          this.inspectReportTotalLoading = false;
        }
      }
    },
    // 生成列表和总数接口共用的请求参数，避免 Object.assign 直接污染 queryParam。
    buildInspectReportRequestParams() {
      return this.formatQueryParams(
        Object.assign({}, this.queryParam, this.pagintion)
      );
    },
    // 总数缓存键只包含筛选条件，翻页时复用同一份真实 total。
    buildInspectReportTotalQueryKey(params) {
      const { page, page_size, ...countParams } = params;
      return JSON.stringify(
        Object.keys(countParams)
          .sort()
          .reduce((result, key) => {
            result[key] = countParams[key];
            return result;
          }, {})
      );
    },
    // 清空总数状态，触发下一次列表加载后重新异步统计。
    resetInspectReportTotal() {
      this.total = 0;
      this.inspectReportTotalQueryKey = "";
      this.inspectReportTotalLoading = false;
    },
    // 将页面时间范围统一转换为接口需要的秒级时间戳参数。
    formatQueryParams(params) {
      const {
        into_time,
        out_time,
        sampling_time,
        unload_time,
        ...otherParams
      } = params;
      let time_params = {};
      const timeParams = {
        into_time,
        out_time,
        sampling_time,
        unload_time
      };
      Object.keys(timeParams).map(key => {
        const timerange = timeParams[key];
        if (timerange && timerange.length === 2) {
          time_params[`begin_${key}`] = moment(timerange[0]).unix();
          time_params[`end_${key}`] = moment(timerange[1]).unix();
        }
      });
      return Object.assign(otherParams, time_params);
    },
    // 打开当前预约记录详情。
    onBookingDetail(row) {
      window.open(
        this.$router.resolve(`/rhqy/service/AppointDeliveryRecord/Detail/${row.booking_info_id}`).href,
        "_blank"
      );
    }
  },
  created() {
    this.queryParam = this.getDefaultQueryParam();
    this.$nextTick(() => {
      this.refreshData();
    });
  }
};
</script>
<style lang="less" scoped>
.inspect-total-loading {
  color: #8a6d3b;
  font-size: 12px;
  padding: 6px 0;
}
</style>
